import { useState } from 'react'
import { parseJwt } from '@/utils/helpers'

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem('accessToken')
  )

  const [userData] = useState(
    localStorage.getItem('accessToken')
      ? parseJwt(localStorage.getItem('accessToken') as string)
      : null
  )

  return {
    userData,
    isAuthenticated,
    setIsAuthenticated,
  }
}
